export default __webpack_public_path__ + "static/media/tableInfoBg.51ed480a.png";